<template>
  <div class="page-coop">
    <div class="banner"></div>
    <div class="g-wrap ">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/achievement`">成果转化</el-breadcrumb-item>
        <el-breadcrumb-item>科研单位</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <Card v-for="item in researchList" :data="item" :key="item.id"></Card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getData } from "@/api/app";
import Card from "./card";
export default {
  data() {
    return {
      researchList: []
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    ...mapState("college", ["collegeData"])
  },
  components: {
    Card
  },
  methods: {
    loadData() {
      let params = [
        { Key: "College", Value: this.collegeData.cid, CompareType: "EqualTo" }
      ];
      getData({ name: "Scientific", top: 6, params })
        .then(res => {
          this.researchList = res || [];
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-coop {
  .content {
    display: flex;
    flex-wrap: wrap;
    padding: 40px 0 16px 0;
  }
  .banner {
    background: url(~assets/img/feature/achievement/banner.png) no-repeat center
      top;
    background-size: 100% 100%;
    height: 160px;
  }
}
</style>
